export const enumOrganismeFormationCategorie = {
    ECOLE : "ecole",
    COMPOSANTEECOLE : "composanteEcole"
}